import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { WhiteLayout, SectionHeadLayout } from "netcompany-mdx-slide";
import repository from "./assets/repository.png";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <WhiteLayout title={"Resources"} mdxType="WhiteLayout">
      <h2><a parentName="h2" {...{
          "href": "https://github.com/truongnln2/java-oop-presentation"
        }}>{`https://github.com/truongnln2/java-oop-presentation`}</a></h2>
  <div style={{
        flex: "1",
        position: "relative"
      }}>
    <div style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          alignContent: "center",
          flexDirection: "column"
        }}>
      <img src={repository} style={{
            maxHeight: "100%"
          }} alt="repository" />
    </div>
  </div>
    </WhiteLayout>
    <hr></hr>
    <SectionHeadLayout title={"Thanks for your attention"} mdxType="SectionHeadLayout" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      